import Repository from "./Repository";

const resource = "";

export default {
    insertBrief(payload) {
        return Repository.post(`${resource}/basic/insertbrief`, { payload });
    },
    updateBrief(payload) {
        return Repository.post(`${resource}/basic/updatebrief`, { payload });
    },
    updateCronJob(payload) {
        return Repository.post(`${resource}/basic/updatecron`, { payload });
    },
    updateTexte(payload) {
        return Repository.post(`${resource}/basic/updatetext`, { payload });
    },
    getBrief(id) {
        return Repository.get(`${resource}/basic/getbrief/${id}`);
    },
    searchSepp(payload) {
        return Repository.post(`${resource}/keysearch/searchlive`, { payload });
    },
    checkLader(payload) {
        return Repository.post(`${resource}/basic/checklader`, { payload });
    },
    saveNewAktion(payload) {
        return Repository.post(`${resource}/basic/savenewaktion`, { payload });
    },
    saveNewtext(payload) {
        return Repository.post(`${resource}/basic/savenewtext`, { payload });
    },
    neueAktionSenden(payload) {
        return Repository.post(`${resource}/basic/startaktion`, { payload });
    },
    getVorlagen(art) {
        return Repository.get(`${resource}/basic/textvorlagen/${art}`);
    },
    openCloseChat(type) {
        return Repository.get(`${resource}/basic/chatopenclose/${type}`);
    },
    getChatStatus() {
        return Repository.get(`${resource}/basic/getchatstatus`);
    },
    getAktionen() {
        return Repository.get(`${resource}/basic/getaktionen`);
    },
    getStats() {
        return Repository.get(`${resource}/basic/getstats`);
    },
    getRefs() {
        return Repository.get(`${resource}/basic/getrefs`);
    },
    getChecks() {
        return Repository.get(`${resource}/basic/getchecks`);
    },
    getCrons() {
        return Repository.get(`${resource}/basic/getcrons`);
    },
    getTexte() {
        return Repository.get(`${resource}/basic/getinboxtexte`);
    },
    getVorlagenParsed(art, aid, abs_id, user_id) {
        return Repository.get(`${resource}/basic/parsed_textvorlagen/${art}/${aid}/${abs_id}/${user_id}`);
    },
    getVorlagenParsedId(id, aid, abs_id) {
        return Repository.get(`${resource}/basic/parsed_textvorlagen_id/${id}/${aid}/${abs_id}`);
    },


}
